import { render, staticRenderFns } from "./institute_results.vue?vue&type=template&id=4cec4339&"
import script from "./institute_results.vue?vue&type=script&lang=js&"
export * from "./institute_results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports